import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SroiReportPayloadCreateForm from './SroiReportPayloadCreateForm'

import { useLoadSroiInputsPreset } from '../useLoadSroiInputsPreset'

import { getSroiInputsPresetWasLoadedSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import { SROI_REPORT_PAYLOAD_CREATE } from '../../../../../constants/forms'

function SroiReportPayloadCreate() {
  const sroiInputsPresetWasLoaded = useSelector(getSroiInputsPresetWasLoadedSelector)

  const { t } = useTranslation()

  useLoadSroiInputsPreset({
    formName: SROI_REPORT_PAYLOAD_CREATE
  })

  return (
    <FormDrawerWrapper
      formName={SROI_REPORT_PAYLOAD_CREATE}
      title={t('Create new report')}
      showOpenButton={true}
      openButtonText={t('New Report')}
      isFormLoading={!sroiInputsPresetWasLoaded}
    >
      <SroiReportPayloadCreateForm />
    </FormDrawerWrapper>
  )
}

export default SroiReportPayloadCreate
